<template>
    <MainContent title="Editar abonado">
        <template v-slot:header>
            <h3 class="card-title">Editar abonado</h3>
        </template>

        <template v-slot:content>
            <FormulateForm v-if="abonado" @submit="editarAbonado" v-model="abonado" class="row"  :schema="schema">
                <div class="col-12">
                    <Button type="submit" name="button">Editar</Button>
                </div>
            </FormulateForm>
        </template>
    </MainContent>
</template>

<script>
    import FormulateForm from "@braid/vue-formulate/src/FormulateForm";
    import MainContent from "@/components/backend/components/MainContent";

    export default {
        props: ['lista_id', 'abonado_id'],
        data() {
            return {
                abonado: null,
                schema: [
                    {
                        "label": "Número de abonado",
                        "name": "n_abonado",
                        "validation": "required",
                        "class": "col-12",
                    },
                    {
                        "label": "Nombre",
                        "name": "name",
                        "validation": "required",
                        "class": "col-12",
                    },
                    {
                        "label": "Apellidos",
                        "name": "surnames",
                        "validation": "required",
                        "class": "col-12",
                    },
                    {
                        "label": "Código Postal",
                        "name": "cp",
                        "validation": "",
                        "class": "col-12",
                    },
                    {
                        "type": "date",
                        "label": "Fecha de nacimiento",
                        "name": "fecha_nacimiento",
                        "placeholder": "Apellidos",
                        "validation": "after:01/01/1900",
                        "class": "col-12",
                    },
                    {
                        "label": "Teléfono",
                        "name": "telefono",
                        "validation": "",
                        "class": "col-12",
                    },
                    {
                        "label": "DNI",
                        "name": "dni",
                        "validation": "required",
                        "class": "col-12",
                    },
                    {
                        "label": "IBAN",
                        "name": "iban",
                        "class": "col-12",
                    },
                    {
                        "label": "Email",
                        "name": "email",
                        "validation": "email",
                        "class": "col-12",
                    },
                    {
                        "label": "Provincia",
                        "name": "provincia",
                        "validation": "",
                        "class": "col-12",
                    },
                    {
                        "label": "Localidad",
                        "name": "localidad",
                        "validation": "",
                        "class": "col-12",
                    },
                    {
                        "label": "Domicilio",
                        "name": "domicilio",
                        "validation": "",
                        "class": "col-12",
                        "id": "domicilio"
                    },
                    {
                        "label": "Peña",
                        "name": "penista",
                        "validation": "",
                        "class": "col-12",
                    },
                    {
                        "label": "Empresa",
                        "name": "empresa",
                        "validation": "",
                        "class": "col-12",
                    },
                    {
                        "type": "textarea",
                        "label": "Observaciones",
                        "name": "observaciones",
                        "validation": "",
                        "class": "col-12",
                        "rows": "8",
                        "cols" :"80"
                    },
                ]
            }
        },
        created() {
            this.getAbonado();
        },
        methods: {
            getAbonado : function() {
                const params = {
                    abonado_id: this.abonado_id,
                    filters: {
                        lista_abonado_id: this.lista_id
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.show'), params).then(res => {
                    this.abonado = res.data.data;
                    if (typeof(this.abonado.n_abonado) === 'string') {
                        this.abonado.n_abonado = this.abonado.n_abonado.replace('i', '');
                    }
                });
            },
            editarAbonado() {
                this.abonado.abonado_id = this.abonado_id;
                this.abonado.filters = {
                    lista_abonado_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.editar'), this.abonado).then(() => {
                    this.$router.push({ name: 'back.abonados.index', query: this.$route.query });
                });
            },
        },
        components: {
            MainContent, FormulateForm
        }
    }
</script>
